import { createTeleporter } from 'react-teleporter';

export const SecondaryNavBarRightComponent = createTeleporter();
